import {APIClient} from "../apiCore";
import * as url from "../urls";
import {m9sGlobals} from "../../config";
import {VariantAssignment} from "../../redux/Content/VariantGroup/types";

const api = new APIClient();

const groupUrl = (path: string, uuid: string) => m9sGlobals.CURRENT_CABINET + path.replace(/:uuid/, uuid);

// Feature 012: variant groups (contracts/cabinet-rest.md).
const getVariantGroups = (data: { start?: number; end?: number; status?: string[]; overdue?: boolean; limit?: number }) =>
    api.create(m9sGlobals.CURRENT_CABINET + url.GET_VARIANT_GROUPS, data);

const getVariantGroup = (uuid: string) => api.get(groupUrl(url.GET_VARIANT_GROUP, uuid));

const createVariantGroup = (data: {
    title: string; publishAt: string; channels: string[];
    variants: Array<{ text: string; tags?: string; link?: string }>; requestKey?: string;
    /** post (default), shorts, story or bio. */
    mode?: string;
}) => api.create(m9sGlobals.CURRENT_CABINET + url.CREATE_VARIANT_GROUP, data);

const updateVariantGroup = (uuid: string, data: { title?: string; publishAt?: string; addChannels?: string[]; removeChannels?: string[] }) =>
    api.create(groupUrl(url.UPDATE_VARIANT_GROUP, uuid), data);

const saveVariant = (uuid: string, data: { label?: string; text?: string; tags?: string; link?: string }) =>
    api.create(groupUrl(url.SAVE_VARIANT_GROUP_VARIANT, uuid), data);

const removeVariant = (uuid: string, label: string) =>
    api.delete(groupUrl(url.REMOVE_VARIANT_GROUP_VARIANT, uuid).replace(/:label/, label));

/** Sets a version's media: `keep` are uuids of its files to keep, `files` the new ones; the rest go. */
const saveVariantMedia = (uuid: string, label: string, files: File[], keep: string[] = []) =>
    api.createWithFile(groupUrl(url.SAVE_VARIANT_GROUP_MEDIA, uuid).replace(/:label/, label), {
        media: [...keep.map((k) => ({uuid: k})), ...files.map((file, i) => ({fileName: file.name, sort: keep.length + i}))],
        attachmentFiles: files,
    });

const pickVariants = (uuid: string, data: { preview: boolean; assignments?: VariantAssignment[]; all?: string; now?: boolean }) =>
    api.create(groupUrl(url.PICK_VARIANT_GROUP, uuid), data);

const unassignVariant = (uuid: string, channel: string) =>
    api.create(groupUrl(url.UNASSIGN_VARIANT_GROUP, uuid), {channel});

const dropVariantChannel = (uuid: string, channel: string, restore = false) =>
    api.create(groupUrl(url.DROP_VARIANT_GROUP, uuid), {channel, restore});

const cancelVariantGroup = (uuid: string) => api.create(groupUrl(url.CANCEL_VARIANT_GROUP, uuid), {});

export {
    getVariantGroups,
    getVariantGroup,
    createVariantGroup,
    updateVariantGroup,
    saveVariant,
    removeVariant,
    saveVariantMedia,
    pickVariants,
    unassignVariant,
    dropVariantChannel,
    cancelVariantGroup,
};
